module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.visibleIntegrations), function(integration) {
    return _c('v-flex', {
      key: integration.title,
      attrs: {
        "xs12": "",
        "sm6": "",
        "lg4": ""
      }
    }, [_c('v-card', {
      staticClass: "mb-3",
      attrs: {
        "height": "100%"
      }
    }, [_c('v-list', {
      attrs: {
        "three-line": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('img', {
      staticClass: "mr-3",
      attrs: {
        "height": "50",
        "src": integration.logo
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(integration.title) + "\n              "), (_vm.isInstalled(integration)) ? _c('v-chip', {
      staticClass: "ml-3 v-chip--x-small",
      attrs: {
        "color": "success",
        "label": "",
        "dark": "",
        "small": ""
      }
    }, [_vm._v("\n                Installed\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": integration.serviceURL,
        "target": "_blank"
      }
    }, [_vm._v("\n                Open " + _vm._s(integration.title) + "\n                "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)])], 1), _vm._v(" "), _c('v-list-tile-action', [(integration.installPath) ? _c('v-btn', {
      attrs: {
        "small": "",
        "to": integration.installPath,
        "color": "primary"
      }
    }, [_vm._v("\n                Manage\n                ")]) : _vm._e(), _vm._v(" "), (integration.installURL) ? _c('v-btn', {
      attrs: {
        "href": integration.installURL,
        "color": "primary"
      }
    }, [_vm._v("\n                " + _vm._s(integration.cta) + "\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(integration.tagline) ? _c('blockquote', {
      staticClass: "blockquote"
    }, [_vm._v(_vm._s(integration.tagline))]) : _vm._e(), _vm._v(" "), (integration.description) ? _c('p', {
      attrs: {
        "vhtml": "integration.description"
      }
    }) : _vm._e(), _vm._v(" "), (integration.features) ? _c('ul', [_c('v-subheader', {
      staticClass: "ml-0 pl-0"
    }, [_vm._v("Features")]), _vm._v(" "), _vm._l((integration.features), function(feature, index) {
      return _c('li', {
        key: index,
        staticClass: "ml-4"
      }, [_vm._v("\n            " + _vm._s(feature) + "\n          ")])
    })], 2) : _vm._e()]), _vm._v(" "), (integration.helpDocs && integration.helpDocs.length > 0) ? _c('v-card-actions', [_c('v-btn', {
      staticClass: "ml-4",
      attrs: {
        "color": "primary",
        "outline": ""
      }
    }, [_vm._v("Learn more\n          "), _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, on), [_c('v-icon', [_vm._v("expand_more")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((integration.helpDocs), function(doc) {
      return _c('v-list-tile', {
        key: doc.title
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(doc.title))])], 1), _vm._v(" "), (doc.video) ? _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "href": doc.video,
          "target": "_blank",
          "icon": ""
        }
      }, [_c('v-icon', [_vm._v("videocam")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
        attrs: {
          "href": doc.link,
          "target": "_blank",
          "icon": ""
        }
      }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecd6d91a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/IntegrationsList.vue
// module id = 1543
// module chunks = 9